import {VideoCreationType} from "../VideoCreationType";

export const videoCreationTypeOptions = [
    {value: VideoCreationType.VENDOR.toString(), label: "Reklamowa dewelopera"},
    {value: VideoCreationType.EDUCATIONAL.toString(), label: "Edukacyjna"},
    {value: VideoCreationType.DOMESTIC.toString(), label: "Wewnętrzna"}
];
